import actionTypes from './actionTypes'
import { AnyAction } from 'redux'

const initialize = (): AnyAction => {
	return {
		type: actionTypes.PREVIEW_INITIALIZE,
	}
}

const previewDataSuccess = (activities: any[]): AnyAction => {
	return {
		type: actionTypes.PREVIEW_DATA_SUCCESS,
		activities,
	}
}

export default {
	initialize,
	previewDataSuccess,
}
